<template>
  <div>
    <div>
      <aha-modal
        @hide="hide()"
        title="Create New Folder"
        action-position="justify-end"
      >
        <form @submit.prevent="handleCreateNewFolder()">
          <aha-input
            focus
            v-model="folderName"
            id="input_folder-name"
            :maxLength="limitFolderName"
          />
        </form>
        <template #action>
          <aha-link @click="hide()">
            <span class="font-bold">Cancel</span>
          </aha-link>
          <aha-button
            :disabled="isCreatingFolder"
            @click="handleCreateNewFolder()"
            icon-name="add"
            :submitting="isCreatingFolder"
            has-margin-left
          >
            <aha-spinner variant="white" v-if="isCreatingFolder" class="mr-1" />
            Create Folder
          </aha-button>
        </template>
        <p class="pt-2 text-red-50" v-if="textError">
          {{ textError }}
        </p>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

// api
import FolderApi from '@/api/folder'
import PresentationApi from '@/api/presentation'

// utils
import utils from '@/util'
import EventBus from '@/eventBus'

// constants
import constants from '@/constant'

export default {
  props: {
    presentationIds: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      folderName: '',
      isCreatingFolder: false,
      limitFolderName: 100,
      textError: '',
    }
  },
  methods: {
    ...mapActions(['setErrorOnInternalServerAction']),
    gaTrackEvent(label, value) {
      utils.gaTrackEvent(
        constants.gaCategories.PRESENTATION_LIST,
        label,
        value,
      )
    },
    async handleCreateNewFolder() {
      this.gaTrackEvent('New > Create New Folder > Submit', `Folder name: ${this.folderName}`)

      if (this.folderName.trim() === '') {
        this.textError = 'Please enter a name for folder.'
        return
      }

      this.isCreatingFolder = true

      try {
        const result = await FolderApi.createFolder({
          folderName: this.folderName.trim(),
        })

        if (this.presentationIds.length) {
          await this.handleMovePresnToNewFolder(result)
        } else {
          utils.showToastSuccess(`Created folder "${this.folderName.trim()}"`)
        }

        this.hide()
        EventBus.$emit('reload-presentations-and-folders')
        this.gaTrackEvent('New > Create New Folder > Succeeded', `Folder name: ${this.folderName}`)
      } catch (error) {
        if (error.body.message === 'folderName must be unique') {
          this.textError = 'This folder name is already in use, please enter something else.'
        } else {
          this.setErrorOnInternalServerAction(`Cannot create folder: ${this.folderName}`)
        }

        this.gaTrackEvent('New > Create New Folder > Failed', `Error: ${error.body.message}`)
      }

      this.isCreatingFolder = false
    },
    async handleMovePresnToNewFolder(result) {
      const payload = {
        presentationIds: this.presentationIds,
        presentation: { folderId: result.folder.folderId },
      }

      try {
        await PresentationApi.patchPresentations(payload)
      } catch (error) {
        utils.showToastError('Move presentations failed')
        this.gaTrackEvent(
          'Presentation List > Move Presentation to new folder > Failed',
          error.body ? error.body.message : '',
        )
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
